import { connect } from "react-redux";
import ListGroupsComponent from "../../Components/Groups/ListGroupsComponent";
import { setGroups } from "../../Redux/Actions/GroupsActions";
const mapStateToProps = (state) => ({
    ST_GROUPS: state.reducer.ST_GROUPS,
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    SCOPES_NAMES: state.reducer.SCOPES_NAMES,
});
const mapDispatchToProps = (dispatch) => ({
    setGroups : (GROUPS) => dispatch(setGroups(GROUPS)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(ListGroupsComponent);